import React from "react";
import { useTranslation } from "react-i18next";
import * as _ from "lodash";
import MainHeader from "../../components/common/MainHeader";
import ReportExportButton from "../../components/common/ReportExportButton";
import { URL_REPORT } from "../../constance/urls";
import { WASTE_WOOD_ORDER_TYPE } from "../../constance/dataTypes";
import { Layout, Form, Row, Col, DatePicker, Tooltip, Select } from "antd";
import { Content } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { HUMAN_DATE_FORMAT, DATE_FORMAT } from "../../constance/strings";
import moment from "moment";
import dayjs from "dayjs";

export default function PostBakingWasteWoodInputSummaryReportView() {

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dateRange = Form.useWatch('dateRange', form)
  const orderType = Form.useWatch('order_type', form)
  const dateTypeFiter = Form.useWatch('type', form)
  const haveDateRange = _.get(dateRange, 0, null) && _.get(dateRange, 1, null)
  const { RangePicker } = DatePicker;
  return (
    <div>
      <Layout>
        <Content style={{ margin: '24px', marginTop: '7em' }}>
          <MainHeader />
          <Title level={2}>{t('menus.report_menus.waste_woods.post_baking_waste_wood_input_summary')}</Title>

          <Form form={form} initialValues={{ type: 'date' }}>
            <Row gutter={16} justify={'center'}>
              <Col sm={24} md={24} lg={6} style={{width: '100%'}}>
                <Form.Item name='type' label={t('date_type')}>
                  <Select
                    format={HUMAN_DATE_FORMAT}
                    placeholder={t('date')}
                    options={[
                      { key: 'date', value: 'date', label: t('post_baking_waste_wood_count.group_date') },
                      { key: 'input_date_range', value: 'input_date_range', label: t('post_baking_waste_wood_input.input_date') },
                    ]}
                    style={{width: '100%'}}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={6} style={{width: '100%'}}>
                <Form.Item name='dateRange' label={t('date')}>
                  <RangePicker
                    format={HUMAN_DATE_FORMAT}
                    placeholder={[
                      t('searchs.placeholders.startDate'),
                      t('searchs.placeholders.endDate'),
                    ]}
                    style={{width: '100%'}}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }}>
                <Form.Item label={t('post_baking_waste_wood_input.waste_wood_group')} name='order_type'>
                  <Select
                    allowClear
                    options={[
                      { value: WASTE_WOOD_ORDER_TYPE.SHAPING_TYPE, label: t('waste_wood_order_types.shaping_type') },
                      { value: WASTE_WOOD_ORDER_TYPE.GRADING_TYPE, label: t('waste_wood_order_types.grading_type') },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <Tooltip title={ !haveDateRange? t('searchs.placeholders.date'): ""}>
            <span>
              <ReportExportButton
                url={`${URL_REPORT.POST_BAKING_WASTE_WOOD_INPUT_SUMMARY_REPORT}pdf/`}
                title={t('menus.report_menus.waste_woods.post_baking_waste_wood_input_summary')}
                type='pdf'
                disabled={!haveDateRange}
                params={{
                  order_type: orderType,
                  [`${dateTypeFiter}_after`]: _.get(dateRange, 0, null) ? dayjs(dateRange[0]).format(DATE_FORMAT) : null,
                  [`${dateTypeFiter}_before`]: _.get(dateRange, 1, null) ? dayjs(_.get(dateRange, 1)).format(DATE_FORMAT) : null,
                }} />
            </span>
          </Tooltip>
          <Tooltip title={!haveDateRange ? t('searchs.placeholders.date') : ""}>
            <span>
              <ReportExportButton
                url={`${URL_REPORT.POST_BAKING_WASTE_WOOD_INPUT_SUMMARY_REPORT}excel/`}
                title={t('menus.report_menus.waste_woods.post_baking_waste_wood_input_summary')}
                type='excel'
                disabled={!haveDateRange}
                params={{
                  order_type: orderType,
                  [`${dateTypeFiter}_after`]: _.get(dateRange, 0, null) ? dayjs(dateRange[0]).format(DATE_FORMAT) : null,
                  [`${dateTypeFiter}_before`]: _.get(dateRange, 1, null) ? dayjs(_.get(dateRange, 1)).format(DATE_FORMAT) : null,
                }} />
            </span>
          </Tooltip>
        </Content>
      </Layout>
    </div>
  )
}

